/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{ArcadeExecutionError as e,ExecutionErrorCodes as r}from"./executionError.js";function n(n){if("string"==typeof n)return n.toLowerCase();if("name"in n)return n.name.toLowerCase();if("string"!=typeof n.value)throw new e(null,r.InvalidIdentifier,null);return n.value.toLowerCase()}export{n as toSymbolId};
